/**
 * **「이 화면에 자료가 없다」는 되묻기는 사람에게 낼 말이 아니다.**
 *
 * 「모바일 근태 알림 뒤로 출퇴근을 더 잘 찍나」에 계획이 일근태등록을 고르고, 상세 표에 일자 칸이 없다며
 * 「다른 화면이나 자료를 지정해 주시겠어요?」로 되물었다(실제 테넌트, 2026-10-19). 사람은 어느 화면에 그
 * 자료가 있는지 모른다 — 화면 목록을 가진 것은 우리다. 묻는 까닭이 「무엇을 원하나」가 아니라 「자료가
 * 없다」면 한 번 다시 계획해 스스로 찾게 한다.
 */
const GAP = /(컬럼|칸|열|조회\s*조건|검색\s*조건|키)\S*\s*(이|가)?\s*없|다른\s*(화면|자료)/;

export function asksForDataGap(ask: { question: string; reason: string }): boolean {
  return GAP.test(ask.question) || GAP.test(ask.reason);
}

export const DATA_GAP_NOTE = '직전 계획이 자료가 없다며 사용자에게 화면을 물었다.'
  + ' 화면 목록에서 그 자료를 가진 다른 화면이나, 위 표 행마다 아래 표를 펼쳐 읽는 조회(sweep)로 스스로 찾아라.'
  + ' 사용자는 어느 화면인지 모른다 — 되묻지 마라. 정말 어느 화면에도 없을 때만 그 사실을 답하라.';
